import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import {
  CardContainer,
  ContentWrapper,
  ExpandIcon,
  IconContainer,
} from "./style";

interface ICardProps {
  content: string;
  onClick: () => void;
  icon?: React.ReactNode;
  iconColor?: string;
}

export const Card: React.FC<ICardProps> = ({
  content,
  onClick,
  icon,
  iconColor,
}) => {
  return (
    <CardContainer onClick={onClick} gap={4}>
      <Flex alignItems="center" justifyContent="space-between" gap={2}>
        {icon && <IconContainer>{icon}</IconContainer>}

        <ExpandIcon
          style={{
            color: iconColor || "#9333EA",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke={iconColor || "#9333EA"}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M7.5 17L17 7.5m0 0H10m7 0v7"
            />
          </svg>
        </ExpandIcon>
      </Flex>

      <ContentWrapper>
        <Text
          color="gray.700"
          fontSize="14px"
          lineHeight="1.5"
          textAlign="left"
          wordBreak="break-word"
          noOfLines={3}
        >
          {content}
        </Text>
      </ContentWrapper>
    </CardContainer>
  );
};
